import type { Axios } from "axios";
import type { UseQueryOptions } from "@tanstack/react-query";
import type { CommunityDetails } from "@/models";

export const getCommunityDetailsById = async (
  axiosInstance: Axios,
  communityId: number | string
): Promise<CommunityDetails | null> => {
  try {
    if (typeof communityId === "string" && Number.isNaN(communityId)) {
      return null;
    }
    const response = await axiosInstance.get<CommunityDetails>(
      `/communities/${communityId}/details`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching community details with id ${communityId}:`,
      error
    );
    throw error;
  }
};

export const getCommunityDetailsByIdQuery = (
  axiosInstance: Axios,
  communityId: number | string
): UseQueryOptions<CommunityDetails | null> => ({
  queryKey: ["communityDetails", communityId],
  queryFn: () => getCommunityDetailsById(axiosInstance, communityId)
});
